/**
 * useIsAdult — «er den innloggede en voksen?» (#153).
 *
 * Voksen betyr rollen `admin` (MAPPING.md §4). Før denne fantes ble sjekken
 * skrevet ut på stedet, `session?.member?.role === 'admin'`, i et dusin filer;
 * ny kode bruker hooken. Uten økt, og mens økten lastes, er svaret `false` —
 * serveren er porten for alt voksent, dette styrer bare hva som vises.
 */
import { useSession } from './useSession';

export function useIsAdult(): boolean {
  const { data } = useSession();
  return data?.member?.role === 'admin';
}
